import {
  ENROLL_KINDBRIDGE_CONFIRMATION,
  ENROLL_KINDBRIDGE_FAIL,
  ENROLL_KINDBRIDGE_SUCCESS,
  ENROLL_KINDBRIDGE_TITLE
} from '@bo-constants/member/memberCopy';
import { useCallback, useMemo } from 'react';
import { MemberConfirmationModal } from '@bo-components/members/modal';
import { classNames } from '@library/utils';
import { isConfirmationErrorMessage } from '@bo-utils/members/memberCommon';
import { useMemberHeaderKebabActions } from '@bo-hooks/members';

export interface MemberEnrollKindbridgeModalProps {
  memberId: string;
  onClose: () => void;
}

export const MemberEnrollKindbridgeModal = ({
  memberId,
  onClose
}: MemberEnrollKindbridgeModalProps) => {
  const {
    isActionError,
    isActionSuccess,
    isButtonDisabled,
    onSubmitEnrollKindbridge
  } = useMemberHeaderKebabActions();

  const confirmationMessage = useMemo(() => {
    if (isActionSuccess) {
      return ENROLL_KINDBRIDGE_SUCCESS;
    }
    if (isActionError) {
      return ENROLL_KINDBRIDGE_FAIL;
    }
    return undefined;
  }, [isActionError, isActionSuccess]);

  const isErrorMessage = useMemo(
    () => isConfirmationErrorMessage(confirmationMessage),
    [confirmationMessage]
  );

  const handleSubmit = useCallback(async () => {
    await onSubmitEnrollKindbridge?.(memberId);
  }, [memberId, onSubmitEnrollKindbridge]);

  return (
    <MemberConfirmationModal
      childrenClassName="justify-evenly py-4 min-h-32"
      className="w-[25rem]"
      handleConfirm={handleSubmit}
      isButtonDisabled={isButtonDisabled}
      isOpen
      label={ENROLL_KINDBRIDGE_TITLE}
      onCancelModal={onClose}
      showConfirmationMessage={!!confirmationMessage}
    >
      {!confirmationMessage ? (
        <p className="text-soClean-180 pb-4 text-sm">
          {ENROLL_KINDBRIDGE_CONFIRMATION}
        </p>
      ) : (
        <p
          className={classNames(
            'text-sm',
            isErrorMessage ? 'text-roses' : 'text-soClean-180'
          )}
        >
          {confirmationMessage}
        </p>
      )}
    </MemberConfirmationModal>
  );
};
